import React, { useEffect } from 'react';
import { Result, Button } from 'antd';
import { useApolloClient, useMutation } from '@apollo/client';
import { Link } from 'react-router-dom';
import { useQueryParams } from 'hooks';
import { GET_AUTH, LOGOUT } from 'gql/auth';

const env = process.env.REACT_APP_ENV;

const SessionTimeout = () => {
  const redirect = useQueryParams()?.get('redirect') ?? '/';
  const client = useApolloClient();
  // eslint-disable-next-line no-unused-vars
  const [logout, { loading }] = useMutation(LOGOUT, {
    update: (cache) => {
      cache.writeQuery({
        query: GET_AUTH,
        data: {
          auth: { token: '', isLoggedIn: false, loading: false, me: null },
        },
      });
    },
    onCompleted: () => {
      localStorage.removeItem('token');
      client.resetStore().then(() => {
        client.cache.writeQuery({
          query: GET_AUTH,
          data: {
            auth: { token: '', isLoggedIn: false, loading: false, me: null },
          },
        });
      });
    },
  });

  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <Result
      title="Your session has expired due to inactivity"
      subTitle="Please login again to continue"
      style={{
        margin: 'auto',
      }}
      extra={
        <Button type="primary" key="console">
          <Link
            to={`/login?local=${env === 'DEVELOPMENT'}&redirect=${redirect}`}
          >
            Go Login
          </Link>
        </Button>
      }
    />
  );
};

export default SessionTimeout;
